export function PublicLeadSection({
  attributionText = "",
  body,
  contactEmail = "",
  contactPhone = "",
  form,
  id = "updates",
  interestOptions = [],
  kicker,
  onChange,
  onSubmit,
  submitted = false,
  submitting = false,
  title,
  workspaceLabel
}) {
  const options = interestOptions.length > 0
    ? interestOptions
    : [
      { value: "opening_updates", label: "Opening updates" },
      { value: "events_classes", label: "Events and classes" },
      { value: "general", label: "General question" }
    ];
  return (
    <div className="public-lead-panel" id={id}>
      <div>
        <span className="public-section-kicker">{kicker}</span>
        <strong>{title}</strong>
        <p>{body}</p>
        <div className="public-lead-actions">
          {contactPhone && <a href={`tel:${contactPhone}`}>Call {contactPhone}</a>}
          {contactEmail && <a href={`mailto:${contactEmail}`}>Email {workspaceLabel}</a>}
        </div>
        {attributionText && (
          <div className="public-campaign-chip">
            Campaign: {attributionText}
          </div>
        )}
      </div>
      <form className="public-lead-form" onSubmit={onSubmit}>
        <div className="public-lead-fields">
          <label>
            <span>Name</span>
            <input
              required
              type="text"
              value={form.name}
              onChange={(event) => onChange({ name: event.target.value })}
              placeholder="Your name"
            />
          </label>
          <label>
            <span>Email</span>
            <input
              required
              type="email"
              value={form.email}
              onChange={(event) => onChange({ email: event.target.value })}
              placeholder="you@example.com"
            />
          </label>
          <label>
            <span>Phone</span>
            <input
              type="tel"
              value={form.phone}
              onChange={(event) => onChange({ phone: event.target.value })}
              placeholder="Optional"
            />
          </label>
          <label>
            <span>Interest</span>
            <select
              value={form.interest}
              onChange={(event) => onChange({ interest: event.target.value })}
            >
              {options.map((option) => (
                <option value={option.value} key={option.value}>
                  {option.label}
                </option>
              ))}
            </select>
          </label>
        </div>
        <label className="public-lead-message">
          <span>Note</span>
          <textarea
            value={form.message}
            onChange={(event) => onChange({ message: event.target.value })}
            placeholder={`Optional context for the ${workspaceLabel}`}
            rows={3}
          />
        </label>
        <div className="public-lead-submit">
          {submitted && <span>Request received.</span>}
          <button type="submit" className="primary-button" disabled={submitting}>
            {submitting ? "Sending..." : "Get updates"}
          </button>
        </div>
      </form>
    </div>
  );
}
